function path(root, sublink) {
  return `${root}${sublink}`;
}
function generatePaths(rootPath, sublink) {
  return {
    ROOT: path(rootPath, sublink),
    ADD: path(rootPath, `${sublink}/add`),
    EDIT: id => path(rootPath, `${sublink}/${id}`),
  };
}

export const ROOT_AUTH = '/';
export const ROOT_APP_OVERVIEW = '/app/overview';
export const ROOT_APP_MANAGEMENT = '/app/management';
export const ROOT_APP_APPLICATION = '/app/application';
export const ROOT_APP_FORM = '/app/form';
export const ROOT_DOCS = '/docs';
export const ROOT_APP_ACCOUNT = '/app/account';

export const PATHS_AUTH = {
  ROOT: ROOT_AUTH,
  LOGIN: path(ROOT_AUTH, 'login'),
  REGISTER: path(ROOT_AUTH, 'register'),
};

export const ROOT_APP = '/app';

export const PATHS_APP_OVERVIEW = {
  ROOT: ROOT_APP_OVERVIEW,
  DASHBOARD: path(ROOT_APP_OVERVIEW, '/dashboard'),
  ACTIVITIES: path(ROOT_APP_OVERVIEW, '/activities'),
  TRANSACTIONS: path(ROOT_APP_OVERVIEW, '/transactions'),
};

export const PATHS_MANAGEMENT = {
  ROOT: ROOT_APP_MANAGEMENT,
  USERS: {
    ROOT: path(ROOT_APP_MANAGEMENT, '/users'),
    EDIT: userId => path(ROOT_APP_MANAGEMENT, `/users/${userId}`),
  },
  MEDIA: generatePaths(ROOT_APP_MANAGEMENT, '/media'),
  LANGUAGES: {
    ...generatePaths(ROOT_APP_MANAGEMENT, '/languages'),
    ADD_TRANSLATION: languageId => path(ROOT_APP_MANAGEMENT, `/languages/${languageId}/translations/add`),
    EDIT_TRANSLATION: (languageId, translationId) =>
      path(ROOT_APP_MANAGEMENT, `/languages/${languageId}/translations/${translationId}`),
  },
  PROMO_CODES: generatePaths(ROOT_APP_MANAGEMENT, '/promo-codes'),
  PRODUCTS: generatePaths(ROOT_APP_MANAGEMENT, '/products'),
  PRODUCT_PACKAGES: generatePaths(ROOT_APP_MANAGEMENT, '/product-packages'),
  VIDEOS: generatePaths(ROOT_APP_MANAGEMENT, '/videos'),
  LULLABIES: generatePaths(ROOT_APP_MANAGEMENT, '/lullabies'),
  MOTOR_SKILLS: generatePaths(ROOT_APP_MANAGEMENT, '/motor-skills'),
  CATEGORIES: generatePaths(ROOT_APP_MANAGEMENT, '/categories'),
  GAME_TYPES: generatePaths(ROOT_APP_MANAGEMENT, '/game-types'),
  REMOTE_CONFIGS: generatePaths(ROOT_APP_MANAGEMENT, '/remote-configs'),
  WHITELIST_USERS: generatePaths(ROOT_APP_MANAGEMENT, '/whitelist-users'),
};

export const PATHS_APPLICATION = {
  ROOT: ROOT_APP_APPLICATION,
  LOGS: path(ROOT_APP_APPLICATION, '/logs'),
  TICKETS: {
    ROOT: path(ROOT_APP_APPLICATION, '/tickets'),
    EDIT: ticketId => path(ROOT_APP_APPLICATION, `/tickets/${ticketId}`),
  },
};

export const PATHS_FORM = {
  ROOT: ROOT_APP_FORM,
  FEEDBACK: path(ROOT_APP_FORM, '/feedback'),
  CONTACT: path(ROOT_APP_FORM, '/contact'),
  CAREER: path(ROOT_APP_FORM, '/career'),
};

export const PATHS_DOC = {
  ROOT: ROOT_DOCS,
  WELCOME: path(ROOT_DOCS, '/welcome'),
  GETTING_STARTED: path(ROOT_DOCS, '/getting-started'),
  POSTMAN: path(ROOT_DOCS, '/postman'),
  API: path(ROOT_DOCS, '/api'),
  AUTHENTICATION: path(ROOT_DOCS, '/api/authentication'),
  ME: path(ROOT_DOCS, '/api/me'),
  FEEDBACK: path(ROOT_DOCS, '/api/feedback'),
  MAIL: path(ROOT_DOCS, '/api/mail'),
  CACHE: path(ROOT_DOCS, '/api/cache'),
  METADATA: path(ROOT_DOCS, '/api/metadata'),
  LOCALIZATION: path(ROOT_DOCS, '/api/localization'),
  PROMO_CODE: path(ROOT_DOCS, '/api/promo-code'),
  TICKET: path(ROOT_DOCS, '/api/ticket'),
  STORE: path(ROOT_DOCS, '/api/store'),
  REPORT: path(ROOT_DOCS, '/api/report'),
  REALTIME_NOTIFICATION: path(ROOT_DOCS, '/api/realtime-notification'),
  VIDEO: path(ROOT_DOCS, '/api/video'),
  LULLABY: path(ROOT_DOCS, '/api/lullaby'),
  WHITELIST: path(ROOT_DOCS, '/api/whitelist'),
  SUPPORT: path(ROOT_DOCS, '/support'),
  CHANGELOG: path(ROOT_DOCS, '/changelog'),
};
